import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import 'bootstrap';
import App from './app.vue';
//import iView from 'iview';
import {router} from './router/index';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import Ajax from './lib/ajax';
import Util from './lib/util';
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';
import VueFileAgent from 'vue-file-agent';
//import store from './store/index';
import store from './store/index';
import { appRouters, otherRouters } from './router/router';
import './scss/fix.css';

//Vue.use(iView);
Vue.use(DashboardPlugin);
Vue.use(VueFileAgent);

Vue.config.productionTip = false;

if(!abp.utils.getCookieValue('Abp.Localization.CultureName')){
  let language=navigator.language;
  abp.utils.setCookieValue('Abp.Localization.CultureName',language,new Date(new Date().getTime() + 5 * 365 * 86400000),abp.appPath);
}

Vue.filter('highlight', function(word, query){
    var check = new RegExp(query, "ig");
    return word.toString().replace(check, function(matchedText,a,b){
        return ('<strong  style="background-color: #FFFF00">' + matchedText + '</strong>');
    });
  });

Ajax.get('/AbpUserConfiguration/GetAll').then(data=>{
  Util.abp=Util.extend(true,Util.abp,data.data.result);
  new Vue({
    render: h => h(App),
    router:router,
    store:store,
    data: {
      currentPageName: ''
    },
    async mounted () {
      this.currentPageName = this.$route.name as string;
      //Default tenant de inicio
      if (Util.abp.multiTenancy.getTenantIdCookie() === null) {
        Util.abp.multiTenancy.setTenantIdCookie(1)
      }
     
      await this.$store.dispatch({
        type:'session/init'
      })
      if(!!this.$store.state.session.user&&this.$store.state.session.application.features['SignalR']){
        if (this.$store.state.session.application.features['SignalR.AspNetCore']) {
          SignalRAspNetCoreHelper.initSignalR();
        }
      }
      this.$store.commit('app/initCachepage');
      this.$store.commit('app/updateMenulist');
    },
    created () {
      let tagsList: Array<any> = [];
      
      appRouters.map((item) => {
          if (item.children.length <= 1 || item.children[0].path==='') {
              tagsList.push(item.children[0]);
          } else {
              tagsList.push(...item.children);
          }
      });
      this.$store.commit('app/setTagsList', tagsList);
    }
  }).$mount('#app')
})

